import { Skeleton, LoadingState } from '../common';

// First-load placeholder for the Messages page. Mirrors the real layout — the
// four-card day strip over the topic-rail + message pane — using the shared
// global-loading-skeleton blocks, so the page reserves its space and nothing
// jumps when bookings + shifts + staff land. Cold load only; once data has
// landed the hooks hold-until-ready, so day-stepping never returns here.
export function MessagesSkeleton() {
  return (
    <LoadingState label="Loading messages…" className="messages">
      <div className="bw-stats three">
        {[0, 1, 2].map((i) => (
          <div className="bw-stat" key={i}>
            <Skeleton variant="row" />
            <Skeleton variant="stat" />
          </div>
        ))}
      </div>
      <div className="messages-view">
        <aside className="msg-list">
          <Skeleton variant="row" />
          <Skeleton variant="row" />
          <Skeleton variant="row" />
        </aside>
        <section className="msg-pane">
          <Skeleton variant="row" />
          <Skeleton variant="chart" />
        </section>
      </div>
    </LoadingState>
  );
}
